import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingUpscalerConfig } from '@/data/landingConfig/landingUpscalerConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Upscaler } from './schemaObject';

interface Props {}
const ImageUpscaler: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelImageUpscaleV4,
		},
		GenerateLandingLinkService.funnelImageUpscaleV2_2,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_Upscaler} />
			<LandingTemplate
				data={landingUpscalerConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ImageUpscaler;
